import { Injectable } from '@angular/core';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';

@Injectable({
  providedIn: 'root'
})
export class PHBHPFeaturePackageConfigurationService {

  constructor(private service: PHBHPApiService) {
    //this.service.apiUrl ="http://localhost:7000/api/"
  }

  getDepartmentDetails() {
    return this.service.getApi('departments/GetDepartments', true);
  }
  getDepartmentList() {
    return this.service.getApi('Departments/GetDepartments', true);
  }
  createWard(data) {
    return this.service.postApi('Wards/CreateWard', data, true);
  }
  updateWard(id,data) {
    return this.service.putApi('Wards/UpdateWard/' + id, data, true);
  }
  deleteWard(id) {
    return this.service.deleteApi('Wards/DeleteWard/' + id, true);
  }
  getInstitutionsbyId(id, roleId) {
    if(roleId != 3){
      return this.service.getApi('institutions/GetInstitutionsByIds/' + id, true);
    } else {
      return this.service.getApi('institutions/GetInstitutionByGroupId/' + id, true);
    }
  }
  getWardsbyInstitutionId(id) {
    return this.service.getApi('ManageInstitution/GetInstituionWards/'+ id, true);
  }
  getWebKessWardsByInsId(id) {
    return this.service.getApi('CHCIntegration/GetWebKessWardsByInstution/'+ id, true);
  }
  getDepartmentTypeList() {
    return this.service.getApi('Departments/GetDepartmentTypes', true);
  }
  importwebKessWards(id, postData) {
    return this.service.postApi('ManageInstitution/ImportwebKessWards/'+ id, postData,true);
  }
  updatewebKessWards(userId, postData, mapMode) {
    return this.service.postApi('Wards/UpdatewebKessWards/'+ userId, postData,true);
  }
  getCountryList() {
    return this.service.getApi('countries', true);
  }
  getCountry(id) {
    return this.service.getApi('UserProfile/GetUsersByRoleId/' + id, true);
  }
  createCountry(data) {
    return this.service.postApi('UserProfile/AddUser',data, true);
  }
  updateCountry(id, data) {
    return this.service.putApi('Users/UpdateUserDetails/' + id, data, true);
  }
  deleteCountry(id) {
    return this.service.deleteApi('Users/' + id, true);
  }
  createDepartment(data) {
    return this.service.postApi('Departments/CreateDepartment', data, true);
  }
  deleteDepartment(id) {
    return this.service.deleteApi('Departments/DeleteDepartment/' + id, true);
  }
  updateDepartment(id, data) {
    return this.service.putApi('Departments/UpdateDepartment/' + id, data, true);
  }
  getCountriesKeyValuePair() {
    return this.service.getApi("countries/GetCountriesKeyValuePair", true);
  }
  GetInstitutionDetails(id) {
    // tslint:disable-next-line:max-line-length
    return this.service.getApi(`ManageInstitution/GetInstituionDetails/` + id, true);
  }
  uploadImage(data) {
    return this.service.postFileApi('InstitutionImageUploader', data, true);
  }
  getImagesByInstitutionId(id) {
    return this.service.getApi('InstitutionImageUploader/' + id, true);
  }
  deleteImageById(id) {
    return this.service.deleteApi('InstitutionImageUploader/DeleteImageLibrary/' + id, true);
  }
  updateImageById(id, data) {
    return this.service.putFileApi('InstitutionImageUploader/UpdateFile/' + id, data, true);
  }
  createImage(data) {
    return this.service.postFileApi('ImageUploader', data, true);
  }
  getImage() {
    return this.service.getApi('ImageUploader', true);
  }
  deleteImage(id) {
    return this.service.deleteApi('ImageUploader/' + id, true);
  }
  updateImage(id, data) {
    return this.service.putFileApi('ImageUploader/UpdateFile/' + id, data, true);
  }
  createTutorial(data) {
    return this.service.postFileApi('TutorialsUploader', data, true);
  }
  getTutorials() {
    return this.service.getApi('Tutorials/GetTutorials', true);
  }
  deleteTutorial(id) {
    return this.service.deleteApi('TutorialsUploader/' + id, true);
  }
  updateTutorial(id, data) {
    return this.service.putFileApi('TutorialsUploader/' + id, data, true);
  }
  getTutorialsByTutorialId(id) {
    return this.service.getApi('Tutorials/GetTutorialById/' + id, true);
  }
  createConfigDetails(data) {
    return this.service.postApi('ConsumptionConfigs',data, true);
  }
  getConfigDetails(id){
    return this.service.getApi('ConsumptionConfigs/' + id, true);
  }
  getSupportEmailById(id, isInstitution){
    return this.service.getApi(`Institutions/GetSupportEmailById/${id}/${isInstitution}`, true);
  }
}
